import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables.ts'

export class UIAdBlockState {
    private isReady = false
    private forcedAdblockActive = false

    constructor() {
        const delay = 1000
        setTimeout(() => this.isReady = true, delay)
    }

    get isAdblockActive() {
        if(UIUtilsEjsVariables.isUserOnDiscord) return false
        if(!this.isReady) return false
        if(this.forcedAdblockActive) return true
        return window['adsAreGreat'] == undefined
    }

    setAdblockEnabledStatus(adblockEnabled: boolean) {
        this.forcedAdblockActive = adblockEnabled
    }
}
